import { createSlice } from "@reduxjs/toolkit";
import { getReferralTriggerEvents } from "./thunk";
import { PaginationResponse, ResponseData } from "api/types/_public";
import { IOperator } from "api/types/_operator";


export interface IState {
  triggerEvents: ResponseData<IOperator[]> & PaginationResponse | null,
  isTriggerEventLoading: boolean,
  isTriggerEventSuccess: boolean,

  error: any,
};

export const initialState: IState = {
  triggerEvents: null,
  isTriggerEventLoading: false,
  isTriggerEventSuccess: false,

  error: {},
};

const TriggerEventSlice = createSlice({
  name: "TriggerEvent",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //get triggerEvents
    builder.addCase(getReferralTriggerEvents.pending, (state: IState, action: any) => {
      state.isTriggerEventLoading = true
    });
    builder.addCase(getReferralTriggerEvents.fulfilled, (state: IState, action: any) => {
      state.triggerEvents = action.payload.data;
      state.isTriggerEventSuccess = true;
      state.isTriggerEventLoading = false;
    });
    builder.addCase(getReferralTriggerEvents.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isTriggerEventSuccess = false;
      state.isTriggerEventLoading = false;
    });
  },
});

export default TriggerEventSlice.reducer;
